import { Icon, ToolTip, useTranslation } from '@testsigma/atoms';

type AppSigningHeaderType = {
  setOpen: Function;
  onSuccess: Function;
  id: number;
  isUpdate: boolean;
  onCancel: Function;
};

export const AppSigningHeader = (props: AppSigningHeaderType) => {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col gap-6'>
      <div className='flex justify-between'>
        <span className='text-lg font-semibold text-secondary-unique-600'>
          {t('upload.iosapp.signing')}
        </span>
        <ToolTip
          content={t('upload.iosapp.signing.close')}
          placement='bottom'>
          <Icon
            name='close'
            className='text-2xl cursor-pointer'
            onClick={() => {
              props.onCancel();
            }}
          />
        </ToolTip>
      </div>
      <div className='py-2 px-3 flex flex-row gap-2 border rounded-lg bg-primary-50 text-primary-700'>
        <Icon name='info' className='text-xl' />
        <span className='text-sm font-normal inline-flex items-center'>
          {t('upload.iosapp.note')}
        </span>
      </div>
    </div>
  );
};
